import React from 'react';
import { ErrorMessage, FieldProps, FormikValues } from 'formik';
import { Field } from '~/components/Formik';
import {
    outOfRangeText,
    isAbnormalValue,
    detailCollectionValidation,
    detailValueValidation,
    useDebounce,
} from '~/util';

interface ActionResultProps {
    detail: QualityMeasureDetailType;
    readOnly: boolean;
    getName: (x: QualityMeasureDetailType) => null | string;
    checkboxId: string;
    gapCollection: QualityMeasureDetailType[];
    formik: FormikValues;
}
export function ActionResult({
    detail,
    readOnly,
    checkboxId,
    gapCollection,
    getName,
    formik,
}: ActionResultProps) {
    const handleResultsFieldTouched = useDebounce((field, meta) => {
        if (meta.touched) return;
        // Set field "touched" after typing, so we can show error messages in "realtime",
        // but without flashing between each keypress
        formik.setFieldTouched(field.name);
    }, 250);

    function handleResultsChange(
        field: { name: string },
        meta: { touched: boolean },
        event: React.ChangeEvent<HTMLInputElement>
    ) {
        formik.handleChange(event);
        handleResultsFieldTouched(field, meta);
    }

    function validate(value: string) {
        if (!formik.values[checkboxId]) return '';
        if (!value) {
            return detailCollectionValidation(gapCollection, formik, getName);
        }
        return detailValueValidation(value, detail);
    }

    return (
        <Field name={getName(detail)} validate={validate}>
            {({ field, meta }: FieldProps) => (
                <>
                    <div className="gap-action-row-results">
                        <input
                            type="text"
                            {...field}
                            className={`form-control d-inline-block w-75 me-1 foc-action-detail-answer-input ${
                                meta.touched && isAbnormalValue(field.value, detail)
                                    ? 'border-warning'
                                    : ''
                            } ${meta.touched && meta.error ? 'is-invalid' : ''}`}
                            aria-label="Measure Results"
                            disabled={readOnly || !formik.values[checkboxId]}
                            onChange={(e) => handleResultsChange(field, meta, e)}
                        />
                        <span>{detail.units}</span>
                    </div>
                    <div className="text-danger">
                        <ErrorMessage name={field.name} />
                    </div>
                    {meta.touched && isAbnormalValue(field.value, detail) && (
                        <div>
                            <i className="fa-solid fa-warning text-warning me-1" />
                            {outOfRangeText(detail, true)}
                        </div>
                    )}
                </>
            )}
        </Field>
    );
}
